// Libs
import { ReactNode, useRef, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';

// RDS
import Button from '@ramsey-design-system/button';
import { LinkExternalIcon } from '@ramsey-design-system/icons';

// Components
import Dialog from '~fpu/shared/components/Dialog';
import QrCode from '~fpu/shared/components/QrCode';
import { ExpandIcon } from '~fpu/shared/components/icons';

function QrCodePrompt({
  activityUrl,
  slug,
  dialogTitle,
  linkLabel,
  children
}: {
  activityUrl: string;
  slug: string;
  dialogTitle: string;
  linkLabel?: string;
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const btnRef = useRef<HTMLButtonElement>(null);
  const { width } = useWindowSize();
  const isMobile = width < 900;
  const qrSize = isMobile ? 256 : 480;

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
      <div className="flex flex-col items-center">
        <QrCode
          url={activityUrl}
          fileName={`fpu-${slug}-qr-code`}
          elementId={`${slug}-qrc`}
          data-testid={`${slug}-qrc`}
          hasIcon={false}
          size={140}
        />
        <Button
          appearance="subtle"
          data-testid={`expand-${slug}-qr-code`}
          onClick={() => setIsOpen(true)}
          ref={btnRef}
          size="medium"
          icon={ExpandIcon}
          iconPosition="right"
        >
          Expand
        </Button>
      </div>

      <div className="flex flex-col gap-2">
        {children}
        {linkLabel && (
          <Button
            element="a"
            href={activityUrl}
            target="_blank"
            rel="noopener noreferrer"
            appearance="ghost"
            icon={LinkExternalIcon}
            iconPosition="right"
            className="mt-1 self-start"
            data-testid={`${slug}-link`}
          >
            {linkLabel}
          </Button>
        )}
      </div>

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        triggerRef={btnRef}
      >
        <Dialog.Title level="2" className="hidden">
          {dialogTitle}
        </Dialog.Title>

        <QrCode
          url={activityUrl}
          elementId={`${slug}-qrc-expanded`}
          data-testid={`${slug}-qrc-expanded`}
          hasIcon={false}
          size={qrSize}
        />
      </Dialog>
    </div>
  );
}

export default QrCodePrompt;
